const moduleObject = {};

function fillProperty(obj, prop) {
  return obj[prop] ?? {};
}

export function getACEObject() {
  const globalObject = window ?? global ?? moduleObject;
  globalObject.ACE = fillProperty(globalObject, 'ACE');
  const ACE = globalObject.ACE;
  ACE.api = fillProperty(ACE, 'api');
  ACE.api.chat = fillProperty(ACE.api, 'chat');
  ACE.api.cob = fillProperty(ACE.api, 'cob');
  ACE.api.pw = fillProperty(ACE.api, 'pw');
  ACE.config = fillProperty(ACE, 'config');

  globalObject.CallGuide = ACE;

  return ACE;
}
